import styled from "styled-components";

const NumberInputStyled = styled.div`
	width: 15rem;
	padding: 1rem 0;

	.input-number-group {
		display: flex;
		justify-content: center;
		position: relative;

		input[type=number] {
			-moz-appearance: textfield;
			&::-webkit-outer-spin-button,
			&::-webkit-inner-spin-button {
				appearance: none;
				-webkit-appearance: none;
			}
		}

		.input-group-button {
			line-height: 3rem;
		}

		.input-number {
			width: 8rem;
			padding: 0 1.2rem;
			text-align: center;
			outline: none;
			display: block;
			margin: 0;
			border-radius: .5rem;
			border: 1px solid ${props => props.theme.gray};
		}

		.input-number,
		.input-number-decrement,
		.input-number-increment {

			height: 4rem;
			user-select: none;
			min-height: auto;

		}

		.input-number-decrement,
		.input-number-increment {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 4rem;
			background: transparent;
			color: black;
			text-align: center;
			font-weight: bold;
			font-size: 2rem;
			font-weight: 400;
			position: absolute;
		}

		.input-number-decrement {
			left: 0;
			border-right: 1px solid ${props => props.theme.gray};
		}

		.input-number-increment {
			right: 0;
			border-left: 1px solid ${props => props.theme.gray};
		}
	}
`;

export default NumberInputStyled;
